export default {
    'nombre': 'Nombre',
    'menuavatar': {
        'salir': 'Cerrar sesión',
        'verperfil': 'Ver perfil'
    },
    'Partes': 'Partes',
    'Areas': 'Areas',
    'SubAreas': 'SubAreas',
    'DevAreas': 'DevAreas',
    'Sociedades': 'Sociedades',
    'telefono': 'Teléfono',
    'codigo': 'Código',
    'email': 'Email',
    'activo': 'Activo',
    'estado': 'Estado',
    'descripcion': 'Descripción',
    'usuario': 'Usuario',
    'clave': 'Clave',
    'tiposiva': 'Tipos de IVA',
    'descargar': 'Descargar',
    'no-results': 'No hay resultados para la búsqueda',
    'admin': 'Admin',
    'buscar': 'Buscar',
    'editar': 'Editar',
    'eliminar': 'Eliminar',
    'home': {
        'titulo': 'Bienvenido',
        'parrafo': 'Ha instalado correctamente la plantilla del ITI para agilizar nuevos desarrollos de software con tecnología .Net (Core) y VueJS. Antes de empezar le invitamos a consultar toda la información puesta a su disposición en las guías de inicio.',
        'enlaces': 'Enlaces de interés',
        'front': 'Guía de inicio Web',
        'back': 'Guía de inicio Backend',
    },
    'tareas-programadas': 'Tareas Programadas',
    'tarea-programada': 'Tarea Programada',
    'timeout': 'Tiempo máximo (min)',
    'tipo-tarea': 'Tipo de tarea',
    'inicio-automatico': 'Inicio automático',
    'cada': 'Cada',
    'minutos': 'minutos',
    'horas': 'horas',
    'cron': 'Periodicidad',
    'iniciar': 'Iniciar',
    'detener': 'Detener',
    'en-ejecucion': 'En ejecución',
    'repetir-clave': 'Repetir clave',
    'cambiar-clave': 'Cambiar clave',
    'roles': 'Roles',
    'rol': 'Rol',
    'pais': 'País',
    'iso': 'ISO',
    'iban': 'IBAN',
    'nacionalidad': 'Nacionalidad',
    'domGooMaps': 'Dominio de Google Maps',
    'nomIng': 'Nombre en inglés',
    'via': 'Vía',
    'notas': 'Notas',
    'calle': 'Calle',
    'poblacion': 'Población',
    'barrio': 'Barrio',
    'sector': 'Sector',
    'distrito': 'Distrito',
    'abrirficha':'Abrir ficha',
    'seguimiento':'Seguimiento',
    'cita':'Cita',
    'iniconsulta':'Iniciar consulta',
    'mensajes': {
        'save-ok': 'Cambios realizados correctamente',
        'confirmar': 'Confirmación',
        'pregunta-borrar': '¿ Está seguro que quiere eliminar "',
        'ok': 'Correcto'
    },
    'general': {
        'DEEditGridTexts': { 'confirmDeleteMessage': null, 'deleteRow': 'Borrar', 'editRow': 'Editar', 'saveRowChanges': '', 'cancelRowChanges': '' },
        'DEEditGroupTexts': 'Arrastrar cabecera de columna aquí para agrupar.',
        'DEEditSearchTexts': 'Buscar',
        'DEEditNoDataTexts': 'No hay datos que mostrar',
    }, 'api': {
        'OK': 'La solicitud ha tenido éxito',
        'CREATED': 'La solicitud ha tenido éxito y ha llevado a la creación de un recurso',
        'NO_CONTENT': 'La petición se ha completado con éxito pero su respuesta no tiene ningún contenido',
        'BAD_REQUEST': 'El servidor no ha podido procesar la petición',
        'UNAUTHORIZED': 'Es necesario autenticar',
        'FORBIDDEN': 'No se poseen los permisos necesarios',
        'NOT_FOUND': 'Página no encontrada',
        'METHOD_NOT_ALLOWED': 'No se admite el método HTTP solicitado',
        'NOT_ACCEPTABLE': 'No se admite el formato solicitado',
        'CONFLICT': 'Se ha producido un conflicto con el estado actual del servidor',
        'UNSUPPORTED_MEDIA_TYPE': 'El formato multimedia no está soportada por el servidor',
        'INTERNAL_SERVER_ERROR': 'Error interno del servidor'
    },
};
